import { useEffect, useState } from "react";
import "./bulk-upload.scss";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import ImportDataPopup from "@pages/Vendors/Popups/index";
import { toast } from "react-toastify";
import { getValue } from "@utils/lodash";
import { uploadFunctions, uploadLocations } from "@services/location.service";
import { getTemplates } from "@services/vendors.service";
import { QueryRequestHelper } from "@_common/query-request-helper";
import { getEncodedKey } from "@_common/text-helpers";
import { downloadURL } from "@services/auth.service";
import { saveAs } from "file-saver";
import { handleDownloadOnClick } from "@_common/downloadfile";

export default function BulkUploadLocation(props: any) {
  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */

  const [isBulkUploadPopupVisible, setBulkuploadPopupVisibility] = useState(
    false
  );
  const [isDataImported, setIsDataImported] = useState(false);
  const [response, setResponse] = useState({});
  const [locationURL, setLocationURL] = useState("");
  const [functionURL, setFunctionURL] = useState("");

  const [importType, setImportType] = useState("");
  const [importedFile, setImportTedFile] = useState<any>(null);
  const [submitLoading, setSubmitLoading] = useState(false);

  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */

  useEffect(() => {
    getData();
  }, []);
  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */

  const getData = async () => {
    let payload: any = {};
    let queryRequest = QueryRequestHelper(payload);
    try {
      let resp = await getTemplates(queryRequest);
      if (resp) {
        let down1 = getValue(resp, `data`, []);
        setLocationURL(
          getValue(down1, `length`, 0) > 0
            ? getValue(down1, `[${0}].url`, "")
            : ""
        );
        setFunctionURL(
          getValue(down1, `length`, 0) > 0
            ? getValue(down1, `[${5}].url`, "")
            : ""
        );
      }
    } catch (error) {}
  };
  /* -------------------------------------------------------------------------- */
  /*                               Onchange section                             */
  /* -------------------------------------------------------------------------- */
  const handleUpload = async () => {
    if (importedFile) {
      if (importType === "location") {
        try {
          let formData = new FormData();
          formData.append("file", importedFile);
          setSubmitLoading(true);
          let resp = await uploadLocations(formData);
          if (resp) {
            toast.success(getValue(resp, `message`, ""));
            setResponse(getValue(resp, `data`, {}));
            setImportType("");
            setImportTedFile(null);
            importedSuccessfully();
            setSubmitLoading(false);
          } else {
            setSubmitLoading(false);
          }
        } catch (error) {
          setSubmitLoading(false);
        }
      }
      if (importType === "function") {
        try {
          let formData = new FormData();
          formData.append("file", importedFile);
          setSubmitLoading(true);
          let resp = await uploadFunctions(formData);
          if (resp) {
            toast.success(getValue(resp, `message`, ""));
            setResponse(getValue(resp, `data`, {}));
            setImportType("");
            setImportTedFile(null);
            importedSuccessfully();
            setSubmitLoading(false);
          } else {
            setSubmitLoading(false);
          }
        } catch (error) {
          setSubmitLoading(false);
        }
      }
    } else {
      toast.error("Please upload file");
      setSubmitLoading(false);
    }
  };

  const closePopup = () => {
    setBulkuploadPopupVisibility(false);
    setIsDataImported(false);
    setImportTedFile("");
  };
  const handleChangeUpload = async (e: any) => {
    // setImportTedFile(e.target.files[0]);
    setImportTedFile(e[0]);
  };
  const importedSuccessfully = () => {
    setIsDataImported(!isDataImported);
  };
  const handleImportPopup = (value: string) => {
    setBulkuploadPopupVisibility(true);
    setImportType(value);
  };

  const handleDownload = async () => {
    if (importType === "location") {
      // var link = document.createElement("a");
      // link.target = "_blank";
      // link.download = "Contact";
      // link.href = locationURL;
      // link.click();
      // let resp = await downloadURL(getEncodedKey(locationURL));
      // if (resp) {
      //   saveAs(getValue(resp, `data.url`, ""), "Contact");
      // }
      handleDownloadOnClick(locationURL,'Contact')
    }
    if (importType === "function") {
      // var link = document.createElement("a");
      // link.target = "_blank";
      // link.download = "Contact";
      // link.href = functionURL;
      // link.click();
      // let resp = await downloadURL(getEncodedKey(functionURL));
      // if (resp) {
      //   saveAs(getValue(resp, `data.url`, ""), "Contact");
      // }
      handleDownloadOnClick(functionURL,'Contact')
    }
  };

  return (
    <>
      <UncontrolledDropdown>
        <DropdownToggle>
          <div className="add-filter-wrapper__filter-container">
            <div className="cursor-pointer">
              <img
                src="/images/file-upload.svg"
                className="img-fluid add-filter-wrapper__upload-image"
              />
              <p className="add-filter-wrapper__filter-title">BULK UPLOAD</p>
            </div>
          </div>
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem
            onClick={() => {
              handleImportPopup("location");
            }}
          >
            Location
          </DropdownItem>
          <DropdownItem
            onClick={() => {
              handleImportPopup("function");
            }}
          >
            Function
          </DropdownItem>
        </DropdownMenu>
      </UncontrolledDropdown>
      {isBulkUploadPopupVisible && (
        <ImportDataPopup
          handleUpload={handleUpload}
          handleChangeUpload={handleChangeUpload}
          closePopup={closePopup}
          isDataImported={isDataImported}
          setIsDataImported={setIsDataImported}
          importedSuccessfully={importedSuccessfully}
          importedFile={importedFile}
          setImportTedFile={setImportTedFile}
          handleDownload={handleDownload}
          response={response}
          submitLoading={submitLoading}
        />
      )}
    </>
  );
}
